<template>
  <div class="header-wrapper">
    <div class="header-container">
      <div class="header-photo-container">
        <div class="header-photo" :style="tutorial.photo ? { backgroundImage: `url(${tutorial.photo})` } : {}">
          <p v-if="!tutorial.photo" class="photo-placeholder">No photo available</p>
          <input
              type="file"
              id="photo-upload"
              @change="$emit('photo-upload', $event)"
              style="display: none;"
              v-if="isModerator"
          />
          <label v-if="isModerator" for="photo-upload" class="photo-upload-button">📷</label>
        </div>
      </div>

      <div class="header-right">
        <div class="publish-button-container" v-if="isModerator">
          <PublishButton :tutorial="tutorial" :updatePublished="updatePublished"/>
        </div>
        <ContentPageTitle
            :title="tutorial.title"
            :is-editing="activeEditor === 'title' && isModerator"
            @start-editing="$emit('update:active-editor', 'title')"
            @stop-editing="$emit('update:active-editor', null)"
            @update:title="handleTitleUpdate"
        />

        <div class="header-text-description">
          <div class="header-text-description-text">
            <editor-content v-if="activeEditor === 'description'"
                            :editor="descriptionEditor"
                            class="editor descr-editor">
            </editor-content>
            <div
              v-else
              v-html="description"
              class="description-content"
              :class="{ 'editable': isModerator }"
              @click="isModerator && $emit('update:active-editor', 'description')"
            ></div>
            <slot></slot>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ContentPageTitle from "../ContentPageTitle.vue";
import ContentPageInfo from "../ContentPageInfo.vue";
import ContentPageField from "../ContentPageTextField.vue";
import PublishButton from "../../button/PublishButton.vue";
import {EditorContent} from "@tiptap/vue-3";
import {mapGetters} from "vuex";

export default {
  name: "FullWidthPhotoHeader",
  components: {
    PublishButton,
    ContentPageField,
    ContentPageTitle,
    ContentPageInfo,
    EditorContent,

  },
  props: {
    tutorial: {
      type: Object,
      required: true,
    },
    activeEditor: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      default: "Описание не заполнено"
    },
    descriptionEditor: {
      type: Object,
      required: true,
    },
    updatePublished: {
      type: Function,
      required: true,
    },
  },
  computed: {
    ...mapGetters('auth', ['isAdmin', 'isModerator', 'hasRole']),
  },
  methods: {
    handleTitleUpdate(newTitle) {
      this.$emit("update:title", newTitle);
    },
  }
};
</script>

<style scoped>
/* Общие стили для всех редакторов */
:deep(.ProseMirror) {
  outline: none !important;
}

:deep(.ProseMirror-focused) {
  outline: none !important;
}

.header-wrapper {
  background: rgba(255, 255, 255, 0.05);
  border-radius: 15px;
  backdrop-filter: blur(10px);
  padding: 0;
  overflow: hidden;
  margin-top: 30px;
}

.header-container {
  display: flex;
  flex-direction: row;
  gap: 30px;
  margin: 0 auto;
}

.header-photo-container {
  flex: 0 0 45%;
  margin-left: -20px;
}

.header-right {
  flex: 0 0 55%;
  display: flex;
  flex-direction: column;
  gap: 15px;
  padding: 20px 20px 20px 0;
}

.publish-button-container {
  display: flex;
  justify-content: flex-start;
}

:deep(.publish-button) {
  width: auto;
  min-width: 150px;
}

.header-photo {
  background-color: rgba(0, 0, 0, 0.2);
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  width: 100%;
  aspect-ratio: 16/9;
  display: flex;
  justify-content: flex-end;
  border-radius: 0;
  overflow: hidden;
  position: relative;
}

.photo-placeholder {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: var(--my-white);
  opacity: 0.5;
}

.photo-upload-button {
  background: var(--my-links);
  color: var(--my-light);
  width: 35px;
  height: 35px;
  margin: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  border: none;
}

.photo-upload-button:hover {
  background: var(--my-accent);
  transform: translateY(-2px);
}

.header-text-description {
  position: relative;
  display: flex;
  background: rgba(255, 255, 255, 0.02);
  border-radius: 12px;
  padding: 25px;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.header-text-description-text {
  width: 100%;
  color: var(--my-light);
  line-height: 1.6;
  font-size: 15px;
  font-weight: 300;
}

.description-content {
  transition: all 0.3s ease;
}

.description-content.editable {
  cursor: pointer;
  padding: 10px;
  border-radius: 8px;
  transition: all 0.3s ease;
}

.description-content.editable:hover {
  background: rgba(255, 255, 255, 0.05);
}

.description-content.editable:hover::after {
  opacity: 0.7;
}

.editor.descr-editor {
  background: rgba(0, 0, 0, 0.3);
  border-radius: 8px;
  padding: 15px;
  min-height: 100px;
  outline: none !important;
}

/* Убираем outline у всех contenteditable элементов */
:deep([contenteditable]) {
  outline: none !important;
}

@media (max-width: 990px) {
  .header-container {
    flex-direction: column;
  }

  .header-photo-container {
    margin-left: 0;
  }

  .header-right {
    flex: 0 0 100%;
    padding: 20px;
  }
}

@media (max-width: 768px) {
  .header-photo {
    min-height: 150px;
    max-height: 300px;
  }

  .header-text-description {
    padding: 20px;
  }
}
</style>
